export default __webpack_public_path__ + "static/implied-motion-light-04339455c3a4ab72d7c0ecd42695802d.mp4";